var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneySign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.69 19.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.35,1.37c-5.49,0-10.62,4.06-10.62,8.4s5.13,8.41,10.62,8.41S23,14.12,23,9.77s-5.13-8.4-10.61-8.4m0,18.18C5.54,19.55,0,15.16,0,9.77S5.54,0,12.35,0,24.69,4.38,24.69,9.77s-5.54,9.78-12.34,9.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.57,6.89c-1.19.17-1.93.71-1.93,1s.73.86,1.93,1l.14,0V6.87Zm1.51,5.71.14,0c1.08-.18,1.83-.68,1.83-1s-.75-.83-1.83-1l-.14,0Zm-1.37,2.76v-1.3H11.6c-1.63-.17-2.87-.91-3.22-1.91l1.36-.35a2.94,2.94,0,0,0,1.83.8l.14,0V10.35l-.11,0a7.11,7.11,0,0,1-2.29-.71l-.05,0a2.06,2.06,0,0,1-1-1.67c0-1.26,1.37-2.28,3.33-2.49h.11V4.16h1.37V5.43h.11a3.79,3.79,0,0,1,3,1.7l-1.33.49a3,3,0,0,0-1.68-.73l-.14,0V9.24l.1,0a8.34,8.34,0,0,1,2.14.64,2.12,2.12,0,0,1,.52.35,1.59,1.59,0,0,1,.13.13,1.88,1.88,0,0,1,.45,1.19c0,1.22-1.33,2.24-3.23,2.47h-.11v1.31Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneySign);
export default __webpack_public_path__ + "static/media/moneySign.24ac0b93.svg";
export { ForwardRef as ReactComponent };